(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const PARAMETER = 'seibi';

    const initSiteModeHeader = () => {
      const header = document.querySelector('[data-site-mode-header]');
      if (!header || header.dataset.siteModeInitialized === 'true') return;

      header.dataset.siteModeInitialized = 'true';

      const currentUrl = new URL(window.location.href);
      const regularTopUrl = new URL(header.dataset.regularTopUrl || '/pages/seiki', window.location.origin);
      const seibiRootUrl = new URL(header.dataset.seibiRootUrl || '/', window.location.origin);
      const forceRegularMode = header.dataset.forceRegular === 'true';
      const forceSeibiMode = header.dataset.forceSeibi === 'true';
      const normalizePath = (pathname) => pathname.replace(/\/$/, '') || '/';
      const isSeibiTop = normalizePath(currentUrl.pathname) === normalizePath(seibiRootUrl.pathname);
      const isSeibiMode = forceSeibiMode || (!forceRegularMode && (currentUrl.searchParams.has(PARAMETER) || isSeibiTop));
      const mode = isSeibiMode ? 'seibi' : 'regular';

      if (forceRegularMode && currentUrl.searchParams.has(PARAMETER)) {
        currentUrl.searchParams.delete(PARAMETER);
        window.history.replaceState(window.history.state, '', `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`);
      } else if ((forceSeibiMode || isSeibiTop) && !currentUrl.searchParams.has(PARAMETER)) {
        currentUrl.search = currentUrl.search ? `${currentUrl.search}&${PARAMETER}` : `?${PARAMETER}`;
        window.history.replaceState(window.history.state, '', `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`);
      }

      document.documentElement.dataset.siteMode = mode;

      header.querySelectorAll('[data-site-mode-menu-slot]').forEach((slot) => {
        if (isSeibiMode) {
          const slotName = slot.dataset.siteModeMenuSlot;
          const template = header.querySelector(`[data-site-mode-menu-template="seibi-${slotName}"]`);
          if (template) slot.replaceChildren(template.content.cloneNode(true));
        }
        slot.dataset.siteModeReady = 'true';
      });

      const addSeibiParameter = (url) => {
        if (!url.search) {
          url.search = `?${PARAMETER}`;
          return url;
        }
        url.searchParams.set(PARAMETER, '');
        return url;
      };

      const removeSeibiParameter = (url) => {
        url.searchParams.delete(PARAMETER);
        return url;
      };

      const isSameStoreUrl = (url) => url.origin === window.location.origin;
      const isRegularTopUrl = (url) => normalizePath(url.pathname) === normalizePath(regularTopUrl.pathname);
      const isSeibiTopUrl = (url) => normalizePath(url.pathname) === normalizePath(seibiRootUrl.pathname);

      const openSiteSwitchLinkInNewTab = (link, url) => {
        if (!header.contains(link) || link.matches('[data-site-home-link]')) return;

        const isSiteSwitchLink = isSeibiMode ? isRegularTopUrl(url) : isSeibiTopUrl(url);
        if (!isSiteSwitchLink) return;

        link.target = '_blank';
        const relValues = new Set((link.getAttribute('rel') || '').split(/\s+/).filter(Boolean));
        relValues.add('noopener');
        relValues.add('noreferrer');
        link.setAttribute('rel', Array.from(relValues).join(' '));
      };

      header.querySelectorAll('[data-site-home-link]').forEach((link) => {
        const homeUrl = isSeibiMode ? addSeibiParameter(new URL(seibiRootUrl)) : removeSeibiParameter(new URL(regularTopUrl));
        link.href = `${homeUrl.pathname}${homeUrl.search}${homeUrl.hash}`;
      });

      const updateLink = (link) => {
        const rawHref = link.getAttribute('href');
        if (!rawHref || rawHref.startsWith('#') || rawHref.startsWith('mailto:') || rawHref.startsWith('tel:') || rawHref.startsWith('javascript:')) return;

        const url = new URL(rawHref, window.location.href);
        if (!isSameStoreUrl(url)) return;

        if (isRegularTopUrl(url)) {
          removeSeibiParameter(url);
        } else if (isSeibiMode) {
          addSeibiParameter(url);
        }

        link.href = `${url.pathname}${url.search}${url.hash}`;
        openSiteSwitchLinkInNewTab(link, url);
      };

      document.querySelectorAll('a[href]').forEach(updateLink);

      if (isSeibiMode) {
        document.querySelectorAll('form[method="get"], form:not([method])').forEach((form) => {
          const actionUrl = new URL(form.getAttribute('action') || window.location.href, window.location.href);
          if (!isSameStoreUrl(actionUrl) || isRegularTopUrl(actionUrl) || form.querySelector(`input[name="${PARAMETER}"]`)) return;

          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = PARAMETER;
          input.value = '';
          form.appendChild(input);
        });
      }
    };

    initSiteModeHeader();
    document.addEventListener('shopify:section:load', initSiteModeHeader);
  })();

  } catch(e) { console.error(e); }
})();
})();
